import React, { useState, useEffect, Fragment } from "react";
import { IoIosNotificationsOutline } from "react-icons/io";
import { Menu, Transition } from "@headlessui/react";
import Notificational from "../notification/Notificational";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

const Notification = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    let fetching = false;
    const fetchCount = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      if (!token || fetching) return;
      fetching = true;
      try {
        const response = await fetch(`${API_BASE_URL}/user/get-users-notification`, {
          method: "POST",
          headers: { "Content-Type": "application/json", token },
          body: JSON.stringify({ filters: {}, page: 1, limit: 1 }),
          signal: controller.signal,
        });
        const data = await response.json();
        if (!controller.signal.aborted && response.ok && data.success) {
          setCount(data.result.total || 0);
        }
      } catch (error) {
        if (error.name !== "AbortError") console.error("Error fetching notification count:", error);
      } finally {
        fetching = false;
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    window.addEventListener("focus", fetchCount);
    return () => {
      controller.abort();
      clearInterval(interval);
      window.removeEventListener("focus", fetchCount);
    };
  }, []);

  return (
    <div className="relative">
      <Menu as="div" className="relative inline-block text-left">
        {/* Bell Button */}
        <Menu.Button className="relative inline-flex items-center p-2 rounded-full hover:bg-gray-100 focus:outline-none ml-2">
          <IoIosNotificationsOutline className="text-[40px] text-gray-700" />
          {/* Badge */}
         {count !== null && count !== undefined && (
            <span className="absolute -top-1 -right-1 bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full border border-white dark:border-gray-900">
              {count}
            </span>
          )}
        </Menu.Button>

        {/* Dropdown Panel */}
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <Menu.Items className="absolute left-0 z-40 mt-0 w-80 max-h-96 overflow-y-auto rounded-xl shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black/5 focus:outline-none">
            <Notificational setCount={setCount} />
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default Notification;
